// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"261":"f8543651","766":"f8543651"}[chunkId] + ".chunk.css";
};